<template>
  <div class="app-container">
    <el-select
      filterable
      v-model="screen.park_id"
      placeholder="请选择园区"
      :disabled="userInfo.park_id != 0"
      class="screenInput"
      @change="parkChange"
    >
      <el-option label="全部" value="0"></el-option>
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select>
    <div class="btn">
      <el-button
        type="primary"
        @click="(screen.page = 1),  fetchData()"
        style="margin-bottom: 5px; margin-left: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px; margin-left: 5px"
        >重置</el-button
      >
    </div>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column label="序号" width="100">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="园区">
        <template slot-scope="scope">
          <span v-if="scope.row.park">{{ scope.row.park.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="姓名">
        <template slot-scope="scope">
          <span v-if="scope.row.user">{{ scope.row.user.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号">
        <template slot-scope="scope">
          <span v-if="scope.row.user">{{ scope.row.user.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="反馈内容">
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.details"
            placement="top-start"
            width="200"
            trigger="hover"
            :content="scope.row.details"
          >
            <div class="line2"  slot="reference">{{ scope.row.details }}</div>
          </el-popover>
          
          
        </template>
      </el-table-column>
      <el-table-column label="反馈时间">
        <template slot-scope="scope">
          {{ scope.row.create_time }}
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.reply_details"
            placement="top-start"
            width="200"
            trigger="hover"
            :content="scope.row.reply_details"
          >
            <el-tag slot="reference" type="success">
              已回复
              <i class="el-icon-question"></i>
            </el-tag>
          </el-popover>
          <el-tag v-else>待回复</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250px" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="see(scope.row.id)"
            v-if="roles.includes('/feedback/info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="audit(scope.row.id)"
            v-if="roles.includes('/feedback/reply') && !scope.row.reply_details"
            >回复</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="conversion(scope.row)"
            >转为工单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-dialog title="回复" :visible.sync="dialogVisible" width="30%">
      <el-form
        :model="feedbackForm"
        :rules="rules"
        ref="feedback"
        label-width="100px"
      >
        <el-form-item label="回复内容" prop="reply_details">
          <el-input
            :rows="3"
            style="width: 80%"
            type="textarea"
            v-model="feedbackForm.reply_details"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer
      title="查看反馈"
      :visible.sync="logDrawer"
      size="700px"
      direction="rtl"
    >
      <el-timeline :reverse="false" class="card">
        <el-timeline-item
          v-for="(item, index) in logList"
          :key="index"
          :timestamp="item.create_time"
          type="success"
          placement="top"
        >
          <el-card v-if="item.type == 1">
            <h4>反馈内容</h4>
            <p>{{ item.details }}</p>
            <p v-if="item.image">
              <el-image
                v-for="(img, ind) in item.image"
                :key="ind"
                style="width: 100px; height: 100px"
                :src="imageOss + img"
                fit="contain"
                :preview-src-list="$pathDispose(item.image)"
              >
              </el-image>
            </p>
            <p>反馈人：{{ item.user ? item.user.name : "--" }}</p>
            <p>联系方式：{{ item.user ? item.user.phone : "--" }}</p>
          </el-card>
          <el-card v-if="item.type == 2">
            <h4>回复内容</h4>
            <p>{{ item.reply_details }}</p>
            <p>
              回复人：{{ item.reply_user ? item.reply_user.username : "--" }}
            </p>
            <p>
              联系方式：{{ item.reply_user ? item.reply_user.phone : "--" }}
            </p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { lists, reply, info } from "@/api/adviceFeedback";
import { openPark } from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      logDrawer: false,
      logList: [],
      listLoading: true,
      dialogVisible: false,
      feedbackForm: {
        id: "",
        reply_details: "",
        reply_user_id: "",
      },
      rules: {
        reply_details: [
          { required: true, message: "请输入拒绝原因", trigger: "blur" },
        ],
      },
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
      },
      total: 0,
      parkList: [],
      companyList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    conversion(e){
      this.$router.push({
        path: "../repairs/addword",
        query: e,
      });
    },
    // 选中园区
    parkChange(e) {
      this.fetchData(e);
    },
    audit(id) {
      this.dialogVisible = true;
      this.feedbackForm.id = id;
      this.feedbackForm.reply_user_id = this.userInfo.id;
      this.$nextTick(() => {
        this.$refs.feedback.resetFields();
      });
    },
    see(id) {
      info({ id }).then((res) => {
        var arr = [];
        arr[0] = {
          ...res.data.info,
          type: 1,
        };
        if (res.data.info.reply_details) {
          var data = {
            create_time: res.data.info.reply_time,
            type: 2,
            reply_details: res.data.info.reply_details,
            reply_user: res.data.info.reply_user,
          };
          arr.unshift(data);
        }
        this.logList = arr;
        this.logDrawer = true;
      });
    },
    reset() {
      this.screen = {
        park_id: "",
        page: 1,
        page_size: 15,
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    submitForm() {
      var that = this;
      this.$refs.feedback.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              reply(that.feedbackForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  this.$refs.feedback.resetFields();
                  that.dialogVisible = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    fetchData() {
      this.listLoading = true;
      lists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn {
  display: inline-block;
}
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px 5px 0;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
</style>
